require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');



//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/core-js/library/fn/get-iterator.js
// module id = ../../../../core-js/library/fn/get-iterator.js
// module chunks = 3